import { HttpTransportType, HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { TokenService } from "../../../../auth/tokenService";
export class InitializeHubService {
    static componentName = "initializeHubService";
    static $inject = ["$log", "$rootScope", TokenService.componentName];

    hubConnection: HubConnection;
    mCalculationFinishedHubProxy = null;

    constructor(
        protected $log: ng.ILogService,
        protected $rootScope: ng.IRootScopeService,
        private tokenService: TokenService
    ) {}

    initializeHub() {
        this.hubConnection = new HubConnectionBuilder()
            .withUrl("/api/hubs/ml", {
                accessTokenFactory: () => this.tokenService.accessToken,
                transport: HttpTransportType.WebSockets
            })
            .build();

        this.hubConnection.on("notify", (modelId: $TSFixMe) => {
            this.$rootScope.$broadcast("notify-after-ml-calculation", { modelId });
        });

        this.hubConnection.start();
    }
}

angular.module("topline.services").service(InitializeHubService.componentName, InitializeHubService);
angular.module("topline.services").run([
    "initializeHubService",
    (service: InitializeHubService) => {
        service.initializeHub();
    }
]);
